import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import baoRouter from "./../../services/bao-router";
import BaoDialog from "./../bao-dialog";
class ExportXlsx {
    explorerViewModel: any;
    constructor(exViewModel: any) {
        this.explorerViewModel = exViewModel;
    }
    Export() {
        //Check first if a node is selected
        if (this.explorerViewModel.SelectedNode() == null) {
            var baoDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgExplorerExportXLSX.NoNodeSelected"), "info");
            return;
        }
        this.explorerViewModel.TabPage.IsLoading(true);
        let selectedNode = ko.map.toJS(this.explorerViewModel.SelectedNode(), false, false);
        selectedNode.Nodes = null;
        return Bao.post("Explorer/ExportData", JSON.stringify({
            explorerTypeId: this.explorerViewModel.ExplorerTypeId(),
            explorerLayoutId: null,
            explorerFilterId: this.explorerViewModel.FilterId(),
            node: selectedNode,
            jsonQuickFilter: ko.map.toJS(this.explorerViewModel.GetQuickFilter()),
            sorting: this.explorerViewModel.Sorting(),
            customFilter: null
        }), (value) => {
            this.explorerViewModel.TabPage.IsLoading(false);
            baoRouter.setHash("#document/" + value);
        });
    }
    ;
    init() {
        return this.Export();
    }
    ;
}
export default ExportXlsx;